import { filter } from "lodash";
import * as Yup from "yup";
import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
// material
import { Card, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import { Link as RouterLink, useNavigate } from "react-router-dom";

import { Stack, Container, TextField, Button, MenuItem, Tooltip, IconButton } from "@mui/material";
import Grid from "@mui/material/Grid";
import Select from "react-select";
import {
  fetchBusinessList,
  fetchV2vList,
  fetchChaptList,
  fetchchapterbyuser,
  fetchV2vListByMember,
  fetchLvbCounterWeb,
  strToAmountNumberConvert
} from "src/utils/common";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import DatePicker from "@mui/lab/DatePicker";
// components
import Page from "../components/Page";
import {
  deleteBusiness,
  deleteV2v,
  getlvbsearchcounter,
  GetMemberByChptId
} from "src/api/commonapi";
import { DeleteForever, DeleteOutline, DeleteSharp, EditSharp, Start } from "@mui/icons-material";
import { notification } from "src/utils/messages";
import Deletemodal from "./DeleteModal";
import { CSVLink } from "react-csv";
import moment from "moment";
import { setDefaultOptions } from "date-fns";
import CustomLoader from "src/commonComponents/CustomLoader";

export default function LvbReport() {
  const [filterCounter, setFilterCounter] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filtereddata, setFilteredData] = useState({
    startDate: null,
    endDate: null,
    filterType: 0
  });

  const filterData = async () => {
    let start = moment(filtereddata.startDate).format("DD-MM-YYYY");
    let end = moment(filtereddata.endDate).format("DD-MM-YYYY");
    if (start == "Invalid date" || end == "Invalid date") {
      let notify = notification({
        type: "error",
        message: "Please select the date"
      });
      notify();
    } else {
      let fndata = new FormData();
      fndata.append("startDate", start);
      fndata.append("endDate", end);
      fndata.append("filterType", filtereddata.filterType);
      setIsLoading(true);
      let resp = await getlvbsearchcounter(fndata);
      setIsLoading(false);
      let notify = notification({
        type: resp.status == 0 ? "error" : "success",
        message: resp.message
      });
      notify();
      if (resp.status == 1) {
        let restest = [];
        resp.data.LVB_business_recive_amt = strToAmountNumberConvert(
          resp.data.LVB_business_recive_amt
        );
        restest.push(resp.data);
        setFilterCounter(restest);
      }
    }
  };
  const getCounterData = async () => {
    let test = [];
    setIsLoading(true);
    let res = await fetchLvbCounterWeb(0);
    setIsLoading(false);
    res.LVB_business_recive_amt = strToAmountNumberConvert(res.LVB_business_recive_amt);
    test.push(res);
    await setFilterCounter(test);
  };
  useEffect(async () => {
    getCounterData();
  }, []);

  const expo_columns = [
    { label: "LVB Total V2V", key: "LVB_v2v_count" },
    { label: "LVB Total Business Received", key: "LVB_business_recive_amt" },
    { label: "LVB Total Reference Given", key: "LVB_reference_given_count" },
    { label: "LVB Total Visitor", key: "LVB_visitor_count" }
  ];

  const columns = [
    {
      name: "LVB Total V2V",
      wrap: true,
      selector: (row, key) => row.LVB_v2v_count,
      sortable: true
    },
    {
      name: "LVB Total Business Received",
      wrap: true,
      selector: (row) => row.LVB_business_recive_amt,
      sortable: true
    },
    {
      name: "LVB Total Reference Given",
      wrap: true,
      selector: (row) => row.LVB_reference_given_count,
      sortable: true
    },
    {
      name: "LVB Total Visitor",
      wrap: true,
      selector: (row) => <>{row.LVB_visitor_count}</>,
      sortable: true
    }
  ];
  return (
    <>
      <Page title="LVB Report | Local Vocal Business Group">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4" gutterBottom>
              LVB Report
            </Typography>
          </Stack>
          <Card
            style={{
              padding: "25px",
              paddingBottom: "25px",
              marginBottom: "25px"
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Stack spacing={3} style={{ marginBottom: "15px" }}>
                  <RadioGroup
                    style={{ marginTop: "0px" }}
                    row
                    defaultValue={0}
                    // value={getdata.e_type}
                    onChange={(e) => {
                      setFilteredData({
                        ...filtereddata,
                        filterType: e.target.value
                      });
                    }}
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="e_type"
                  >
                    <FormControlLabel
                      value="0"
                      control={<Radio checked={filtereddata.filterType == 0 && true} />}
                      label="Include Default Data"
                    />
                    <FormControlLabel
                      value="1"
                      control={<Radio checked={filtereddata.filterType == 1 && true} />}
                      label="Don't Include Default Data"
                    />
                  </RadioGroup>
                </Stack>
              </Grid>
              <Grid item xs={4}>
                <Stack spacing={3} style={{ marginBottom: "15px", marginTop: "5px" }}>
                  <LocalizationProvider dateAdapter={AdapterDateFns} style={{ marginTop: "15px" }}>
                    <DatePicker
                      type="date"
                      name="startdate"
                      label="Start Date "
                      value={filtereddata?.startDate != null ? filtereddata?.startDate : null}
                      inputFormat="dd/MM/yyyy"
                      onChange={(newDate) => {
                        setFilteredData({
                          ...filtereddata,
                          startDate: newDate
                        });
                      }}
                      renderInput={(params) => <TextField {...params} size="small" />}
                    />
                  </LocalizationProvider>
                </Stack>
              </Grid>
              <Grid item xs={4}>
                <Stack spacing={3} style={{ marginBottom: "15px", marginTop: "5px" }}>
                  <LocalizationProvider dateAdapter={AdapterDateFns} style={{ marginTop: "15px" }}>
                    <DatePicker
                      type="date"
                      name="enddate"
                      label="End Date "
                      value={filtereddata?.endDate != null ? filtereddata?.endDate : null}
                      inputFormat="dd/MM/yyyy"
                      onChange={(newDate) => {
                        setFilteredData({
                          ...filtereddata,
                          endDate: newDate
                        });
                      }}
                      renderInput={(params) => <TextField {...params} size="small" />}
                    />
                  </LocalizationProvider>
                </Stack>
              </Grid>
              <Grid
                item
                xs={4}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start"
                }}
              >
                <div>
                  <Button
                    variant="contained"
                    onClick={() => {
                      filterData();
                    }}
                  >
                    Search
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => {
                      getCounterData();
                      setFilteredData({
                        startDate: null,
                        endDate: null,
                        filterType: 0
                      });
                    }}
                    style={{ marginLeft: "5px" }}
                  >
                    Clear
                  </Button>
                </div>
              </Grid>
            </Grid>
          </Card>

          <Card
            style={{
              paddingTop: "25px",
              paddingBottom: "25px",
              marginBottom: "25px"
            }}
          >
            {filterCounter && (
              <>
                <Button className="btn btn-export">
                  <CSVLink
                    data={filterCounter}
                    headers={expo_columns}
                    filename={"LVBData.csv"}
                    className="btn btn-primary test"
                    target="_blank"
                  >
                    Export CSV
                  </CSVLink>
                </Button>
                <DataTable
                  style={{ overflow: "hidden" }}
                  filter
                  pagination
                  highlightOnHover
                  columns={columns}
                  data={filterCounter}
                  progressPending={isLoading}
                  progressComponent={<CustomLoader />}
                />
              </>
            )}
          </Card>
        </Container>
      </Page>
    </>
  );
}
